import { createLeaderFollowerStore } from 'collaboration-sidebar-common/store/leaderFollowerStore';
import { postMessageStrategy } from 'collaboration-sidebar-common/store/postMessageStrategy';
import { CollaborationSidebarSessionId } from 'collaboration-sidebar-common/utils/magpie';
import * as t from 'collaboration-sidebar-common/utils/schema';
const unreadCommentCountStateSchema = t.object({
  unreadCommentCount: t.number
});
const unreadCommentCountStateKey = `collaboration-sidebar-unread-count-${CollaborationSidebarSessionId}`;
const unreadCommentCountStateActionsFactory = set => ({
  setUnreadCommentCount: count => set({
    unreadCommentCount: count
  })
});
export const {
  makeLeader: makeUnreadCommentCountLeader,
  makeFollower: makeUnreadCommentCountFollower
} = createLeaderFollowerStore({
  syncStrategyFactory: postMessageStrategy({
    key: unreadCommentCountStateKey,
    valueSchema: unreadCommentCountStateSchema
  }),
  key: unreadCommentCountStateKey,
  actions: unreadCommentCountStateActionsFactory
});
const createUnreadCommentCountFollower = () => makeUnreadCommentCountFollower({
  unreadCommentCount: 0
});
const WINDOW_FOLLOWER_KEY = '__collaborationSidebarUnreadCountFollower__';
export const getWindowCachedUnreadCommentCountFollower = () => {
  const win = window;
  if (!win[WINDOW_FOLLOWER_KEY]) {
    win[WINDOW_FOLLOWER_KEY] = createUnreadCommentCountFollower();
  }
  return win[WINDOW_FOLLOWER_KEY];
};
export const resetUnreadCommentCountFollowerForTesting = () => {
  const win = window;
  if (win[WINDOW_FOLLOWER_KEY]) {
    win[WINDOW_FOLLOWER_KEY].cleanup();
    win[WINDOW_FOLLOWER_KEY] = undefined;
  }
};